// extracted by mini-css-extract-plugin
module.exports = {"text-area":"_2cv_O2vW8009HbaD0hnkyW"};